import React from "react";

export const SelectedWorkCardComponent = (props) => {
  return (
    <div className="workCard">
      <div style={{ position: "relative" }}>
        <img src={props.image} alt="work" />
        <div className="overlay"></div>
        <img src={props.image} alt="work enlarged" className="hover-image" />
      </div>
      <p>{props.overlay}</p>
    </div>
  );
};
